import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ViewChild, forwardRef } from '@angular/core';
import { 
    
} from '@ionic/angular/standalone';

import { MarvDrawerComponent, MarvButtonComponent, MarvTagComponent, MarvImgComponent } from '@marv/components';
import { MarvFileService } from '@marv/services';
import { PhotoGalleryItem, RetailerLogo, RetailerLogoComponent } from '@app/components';
import { Photo } from '@app/models';
import { EpochToStringPipe } from '@app/pipes';
import { MissionTypeService, PhotoService } from '@app/services';

@Component({
    selector: 'app-photo-gallery-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [
        forwardRef(() => MarvDrawerComponent), forwardRef(() => MarvButtonComponent), forwardRef(() => MarvTagComponent), 
        forwardRef(() => MarvImgComponent), EpochToStringPipe, forwardRef(() => RetailerLogoComponent)
    ]
})
export class PhotoGalleryModalComponent  implements OnInit {

    @Input({alias : 'photo', required : true}) photo: PhotoGalleryItem|null = null; 
    @Input({alias : 'photos', required : true}) photos: Array<Photo> = [];  
    @Output() onDidDismiss = new EventEmitter<any>();

    @ViewChild('drawerPhoto') drawerPhoto: MarvDrawerComponent;

    retailerLogo: RetailerLogo; 
    indexPhoto: number = -1;
    
    constructor(
        public missionTypeService: MissionTypeService,
        private photoService: PhotoService
    ) { }

    ngOnInit() {
        
    }
        
    async ngOnChanges(changes: SimpleChanges) {        
        if(changes['photo'] && changes['photo'].currentValue && this.photo){
            this.retailerLogo = new RetailerLogo(this.photo.retailer.name);
            this.indexPhoto = this.photos.findIndex(p => p.uniqid === this.photo?.uniqid);
            this.drawerPhoto.open();
        }
        else{
            this.indexPhoto = -1;
            this.drawerPhoto?.close();
        }
    }
        
    closeDrawer(){        
        this.onDidDismiss.emit();
    }
    
    async downloadPhoto(){
        if(this.photo){
            let response = await this.photoService.downloadFile(this.photo.urlPicture);
            if(response?.body){               
                let fileName = this.photoService.getFileNameFromHeader(response.headers);
                if (fileName === '') {
                    fileName = this.photo.modelName ? this.photo.modelName : 'picture.jpg';
                }  
                MarvFileService.downloadBlob(fileName, response.body);
            }
        }
    }

    previousPhoto() {
        if(this.indexPhoto > 0){
            this.indexPhoto--;
            this.photo = PhotoGalleryItem.FromPhoto(this.photos[this.indexPhoto]);
        }
    }
    
    nextPhoto() {
        if(this.indexPhoto !== -1 && this.indexPhoto < (this.photos.length-1)){
            this.indexPhoto++;
            this.photo = PhotoGalleryItem.FromPhoto(this.photos[this.indexPhoto]);
        }
    }
}
